<script lang="ts" setup>
const props = defineProps<{
  title: string
}>()
</script>

<template>
  <section class="bg-neutral-100 py-10">
    <div class="container">
      <h2 class="mb-10 text-center text-3xl font-medium text-neutral-700">
        {{ props.title }}
      </h2>
      <slot />
    </div>
  </section>
</template>
